import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vuex from "vuex";
import VueCryptojs from "vue-cryptojs";
import VueSweetalert2 from 'vue-sweetalert2';

Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Vuex);
Vue.use(VueCryptojs);
Vue.use(VueSweetalert2);

import 'sweetalert2/dist/sweetalert2.min.css';
import '@sweetalert2/theme-dark/dark.css';
import 'dayjs/locale/th'

import numeral from 'numeral'
Vue.filter("formatNumber", function(value) {
    return numeral(value).format("0,0.00");
});

(async() => {
    await store.dispatch('Initialization')
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})()